import { KemMessageControllerService } from "@ch/generated";
import { handleError } from "@ch/helpers/utils/handleError";

interface MarkMessageAsSeenProps {
  ids: string[];
}

const markMessageAsSeen = async ({ ids }: MarkMessageAsSeenProps) => {
  try {
    const response =
      await KemMessageControllerService.kemMessageControllerMarkAsSeen({
        requestBody: {
          ids,
        },
      });

    return response;
  } catch (error) {
    handleError(error);
    return undefined;
  }
};

export default markMessageAsSeen;
